import * as React from 'react';
import { ConnectorsValue } from '../../../../../../components/CustomFields/Connectors/Value';
import type { WizardOcppChargePointId } from '../../../../../../components/CustomFields/PrefixText';
import { FormReadonly, Section, useWizard, type ValueComponentProps } from '../../../../../../design-system';
import type { FormFields } from '../../../../../../utils/formUtils';
import type { CreateThirdPartyChargePointWizardState, DetailsOther } from '../types';
import { ConfirmationStepForm } from './ConfirmationStepForm';

const detailsFields: FormFields<Pick<DetailsOther, 'ocppChargePointId'>> = {
  ocppChargePointId: {
    id: 'ocppChargePointId',
    label: 'OCPP Charge Point ID',
    valueComponent: ({ value: { prefix, suffix } }: ValueComponentProps<WizardOcppChargePointId>) => (
      <>{`${prefix}-${suffix}`}</>
    ),
  },
};

export const ConfirmationStepOther: React.FC = () => {
  const { state: untypedState } = useWizard();
  const state = untypedState as CreateThirdPartyChargePointWizardState;

  return (
    <ConfirmationStepForm fields={detailsFields}>
      <Section title="Connectors">
        <FormReadonly<DetailsOther>
          fields={[{ id: 'connectors', label: 'Connectors', valueComponent: ConnectorsValue }]}
          initialValues={state}
        />
      </Section>
    </ConfirmationStepForm>
  );
};
